const React = require('react');
const { Router, Switch, Route, Redirect } = require('react-router-dom');

function renderRoutes(routes = [], extraProps = {}, switchProps = {}) {
  return routes
    ? React.createElement(
        Switch,
        switchProps,
        routes.map((route, i) => {
          if (route.redirect) {
            return React.createElement(Redirect, {
              key: route.key || i,
              from: route.path,
              to: route.redirect,
              exact: route.exact,
              strict: route.strict,
            });
          }
          return React.createElement(Route, {
            key: route.key || i,
            path: route.path,
            exact: route.exact,
            strict: route.strict,
            sensitive: route.sensitive,
            render: (props) => {
              const childRoutes = renderRoutes(route.routes, extraProps, {
                location: props.location,
              });
              if (route.component) {
                const Comp = route.component;
                let element = React.createElement(
                  Comp,
                  { ...props, ...extraProps, route },
                  childRoutes,
                );
                if (route.wrappers && route.wrappers.length) {
                  element = route.wrappers.reduceRight((memo, Wrapper) => {
                    return React.createElement(
                      Wrapper,
                      { ...props, ...extraProps, route },
                      memo,
                    );
                  }, element);
                }
                return element;
              }
              return childRoutes;
            },
          });
        }),
      )
    : null;
}

function renderClient(opts) {
  const { routes, history, plugin = {}, initialState } = opts;

  if (history && plugin.onRouteChange) {
    // Match umi3: fire once for the current location (page refresh / first paint).
    // history.listen only notifies on subsequent navigations, not the initial one.
    const handleRouteChange = (location, action) => {
      plugin.onRouteChange({ location, action, routes });
    };
    handleRouteChange(history.location, 'POP');
    history.listen(handleRouteChange);
  }

  return React.createElement(
    Router,
    { history },
    renderRoutes(routes, { initialState }),
  );
}

module.exports = {
  renderClient,
  renderRoutes,
};
